var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogfilesDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 56",
    style: {
      enableBackground: "new 0 0 50 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#B4CCDD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.9,20.5 14,33.5 14,39 19.5,39 32.5,26.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.7,24.8l-5.5-5.5l1.8-1.8c0.7-0.7,1.9-0.7,2.6,0l2.9,2.9c0.7,0.7,0.7,1.9,0,2.6L33.7,24.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogfilesDefault);
export default __webpack_public_path__ + "static/media/logfiles-default.5e6aaa71a4ba14f08931d1f658bc8eaf.svg";
export { ForwardRef as ReactComponent };